import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuAdmin from "../navAdmin/Menu";
import { CurrentUserContext } from "../../../App";
import ContentDetail from "../../public/content/ContentDetail";
import Content from "../../public/content/Content";

export default function ViewAnnouncementAdmin() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [role] = useState(JSON.parse(localStorage.getItem("user")));
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!role.auth.role.includes("ADMIN")) {
      setIsMessage({ type: "warning", data: "ปฏิเสธเข้าถึงข่าวประชาสัมพันธ์" });
      navigate("/admin");
    }
  }, []);

  return (
    <>
      <MenuAdmin menuActive={"news"} />
      <ContentDetail />
    </>
  );
}
